<template>
  <div id="adminRobotsSettingAdmin">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ setting }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Robots.txt</router-link>
      </li>
    </ol>
    <div class="container" style="max-width:100%!important;max-height:100%!important;">
      <div class="tab-pane nopadding" id="tabDetail" role="tabpanel">
        <div class="tab-content">
          <div class="card-body active tab-pane" id="txtRobots">
            <div class="card">
              <div class="row">
                <div class="col">
                  <codemirror v-model="textToSaveRobots" :options="cmOptions"></codemirror>
                </div>
              </div>
              <div class="row">&nbsp;</div>
              <div class="row">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="confirmCancelDataRobots"
                  ><i class="fa fa-times"></i>&nbsp;{{ cancel }}</button>
                  <button type="button" class="btn btn-success" @click="confirmSaveDataRobots"><i class="fa fa-floppy-o"></i>&nbsp;Salva in Robots.txt</button>
                </div>
              </div>
            </div>
          </div>     
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";


export default {
  name: "adminRobotsSettingAdmin",
  components: {
    codemirror
  },
  data() {
    return {
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      confirmCancel: dictionaryHelpers.getDictionary("ConfirmCancel"),
      confirmSave: dictionaryHelpers.getDictionary("ConfirmSave"),
      cmOptions: {
        indentWithTabs: true,
        line: true,
        lineNumbers: true,
        lineWrapping: true,
        mode: "text/css",
        tabMode: "indent",
        tabSize: 4
      },
      textToSaveRobots: "",
      save: dictionaryHelpers.getDictionary("Save"),
      setting: dictionaryHelpers.getDictionary("Setting"),
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname
    };
  },
  created() {
    spinnerHelpers.show();
    this.loadTextRobots();

    setTimeout(function() {
      var height =
        window.innerHeight -
        150 -
        $(".app-header").height() -
        $(".breadcrumb").height() -
        $(".app-footer").height();

      $(".vue-codemirror").height(height);
      $(".CodeMirror").height(height);
      $(".CodeMirror-gutters").css('z-index', '2');
      $(".CodeMirror-gutter-wrapper").css('z-index', '3');
    }, 100);
  },
  methods: {
    loadTextRobots() {
      var adminRobotsSettingAdmin = this;

      RobotsSettingServices.get(function(result) {
        adminRobotsSettingAdmin.textToSaveRobots = result.data.txtRobots;
        $("#txtRobots").addClass("active");
        spinnerHelpers.hide();
      });
    },
   
    confirmCancelDataRobots() {
      if (confirm(this.confirmCancel)) {
        this.executeCancelDataRobots();
      }
    },
    executeCancelDataRobots() {
      spinnerHelpers.show();
      this.loadTextRobots();
      spinnerHelpers.hide();
    },
    confirmSaveDataRobots() {
      if (confirm(this.confirmSave)) {
        this.executeSaveDataRobots();
      }
    },
    executeSaveDataRobots() {
      spinnerHelpers.show();
      var adminRobotsSettingAdmin = this;
      RobotsSettingServices.updateRobots(this.textToSaveRobots, function() {
        notificationHelpers.success(adminRobotsSettingAdmin.updateCompleted);
        adminRobotsSettingAdmin.loadTextRobots();
      });
    }
  }
};
</script>

<style>
.tab-content .tab-pane {
    padding: 1rem;
}
.nav-tabs .nav-links {
    width: 100%;
    border-radius: 0;
    color: #fff;
    background: #73818f;
    border-bottom: 3px solid #936c6c !important;
    border: 0px;
    height: 40px;
}

.nav-tabs .nav-links.active {
  background-color:#936c6c;
}

#adminRobotsSettingAdmin .CodeMirror-gutters, #adminSettinManageStyle .CodeMirror-gutters{
  z-index: 2 !important;
}
#adminRobotsSettingAdmin  .CodeMirror-gutter-wrapper, #adminSettinManageStyle .CodeMirror-gutters-wrapper{
  z-index:3 !important;
}
</style>
